import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select'; // Import React Select
import config from "../../envconfig";
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import axios from "axios"
import { UserContext } from '../common/UserContext';
import { IoCaretDownCircle, IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';
import { useRef } from 'react';
import CustomSingleValue from '../common/CustomSingleValue';


function CMEDIT() {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
    const [message, setMessage] = useState('');
    const { CM_ID } = useParams();
    const navigate = useNavigate();
    const [status, setstatus] = useState()
    const [CMEdit, setCmEdit] = useState({
        CM_CompanyName: '',
        CM_CompanyCode: '',
        CM_Status: 1,
        CM_CompanyGrpId: ''
    });
    const [errors, setErrors] = useState({
        required: {
            CM_CompanyCode: '',
            CM_CompanyName: '',
            CM_CompanyGrpId: '',
        },
        other: {
            CM_CompanyCode: '',
            CM_CompanyName: '',
            CM_CompanyGrpId: '',
        },
    });
    const toastRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const [oldstatus, setoldstatus] = useState()
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Status options for React Select
    const statusOptions = [
        { value: 1, label: 'Active' },
        { value: 2, label: 'Inactive' }
    ];

    const audittransection = async (data) => {
        const formData = {
            AUTRN_ID: data.AUTRN_ID,
            AUTRN_OldValue: data.AUTRN_OldValue ?? null,
            AUTRN_NewValue: data.AUTRN_NewValue,
            AUTRN_ParamererName: data.AUTRN_ParamererName
        };
        try {
            const response = await axios.post(`${config.API_URL}/api/audittransaction`, formData);
        } catch (error) {
            if (error.response) {
                console.error('Server responded with an error:', error.response.data);
            } else if (error.request) {
                console.error('No response received:', error.request);
            } else {
                console.error('Error setting up the request:', error.message);
            }
        }
    }

    // THIS API IS USED TO PRINT THE LOG IN DRIVE D IN LOG FOLDER  

    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const currentTimestamp = getCurrentTimestamp();
        const AUTR_OldValue = details?.AUTR_OldValue ?? null;
        const AUTR_NewValue = details?.AUTR_NewValue ?? null;
        const AUTR_Message = details?.AUTR_Message ?? null;
        const AUTR_AuditType = details?.AUTR_AuditType ?? null;
        const UM_UserId = details?.UM_UserId ?? null;
        const UM_UserCode = details?.UM_UserCode ?? null;
        const selectedScpId = details?.selectedScpId ?? null;
        const UM_CompanyID = details?.UM_CompanyID ?? null;
        const UM_CompanyGrpID = details?.UM_CompanyGrpID ?? null;

        const data = {
            AUTR_ScreenName: "Company Master Edit",
            AUTR_OldValue: AUTR_OldValue,
            AUTR_NewValue: AUTR_NewValue,
            AUTR_Message: AUTR_Message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_TimeStamp: currentTimestamp,
            AUTR_AuditType: AUTR_AuditType,
            AUTR_SCPID: selectedScpId || null,
            AUTR_CompanyGrpId: UM_CompanyGrpID || null,
            AUTR_CompanyID: UM_CompanyID || null,
            AUTR_CreatedBy: UM_UserId,
            AUTR_CreatedDateTime: currentTimestamp
        };

        console.log(data);

        try {
            const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
            console.log('Success:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error:', error);
        }
    };


    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "Company Master Edit:", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };
    // TILL HERE 



    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

    const [groups, setGroups] = useState([]);
    const [companyGroupOptions, setCompanyGroupOptions] = useState([]);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await fetch(`${config.API_URL}/companygroupname`);
                const data = await response.json();

                console.log("CGM_CompanyGroupName data ", data)
                if (response.ok) {
                    if (data.CGM_ID) {
                        setGroups(data.CGM_ID);
                        // Transform data for React Select
                        const options = data.CGM_ID.map(group => ({
                            value: group.CGM_ID,
                            label: group.CGM_CompanyGroupName
                        }));
                        setCompanyGroupOptions(options);
                    } else {
                        console.error('Invalid API response:', data);
                        logAction('fetchGroups():Invalid API response. Please check the server logs.', true)
                    }
                } else {
                    console.error('Error fetching group data. Server returned:', response.status);
                    logAction('fetchGroups():Error fetching group data. Please try again.', true)
                }
            } catch (error) {
                console.error('Failed to fetch group data:', error);
                logAction('fetchGroups():Failed to fetch group data. Please check your network connection.', true)
            }
        };
        fetchGroups();
    }, []);


    const fetchData = async () => {
        try {
            const response = await fetch(`${config.API_URL}/CM/toupdate/${CM_ID}`);
            if (response.ok) {
                const data = await response.json();
                console.log('Fetched Data:', data);
                setstatus(data.CM_Status)
                setCmEdit({
                    CM_CompanyName: data.CM_CompanyName,
                    CM_CompanyCode: data.CM_CompanyCode,
                    CM_CompanyGrpId: data.CM_CompanyGrpId,
                    CM_Status: data.CM_Status,
                });
                setoldstatus(data.CM_Status)

            } else {
                console.error('Error fetching the company data');
                logAction('fetchGroups():Error fetching the company data', true)
            }
        } catch (error) {
            console.error('Error fetching company data:', error);
            logAction('fetchGroups():Error fetching the company data', true)
        }
    };

    useEffect(() => {
        fetchData();
    }, [CM_ID]);

    const validateForm = () => {
        let valid = true;
        const newErrors = {
            required: { ...errors.required },
            other: { ...errors.other },
        };
        logAction('validateForm():Started')

        // Validate CM_CompanyName
        if (!CMEdit.CM_CompanyName) {
            newErrors.required.CM_CompanyName = '*';
            valid = false;
        } else {
            newErrors.required.CM_CompanyName = '';
        }

        // Validate CM_CompanyCode
        if (!CMEdit.CM_CompanyCode) {
            newErrors.required.CM_CompanyCode = '*';
            valid = false;
        } else {
            newErrors.required.CM_CompanyCode = '';
        }
        // Validate CM_CompanyGrpId
        if (!CMEdit.CM_CompanyGrpId) {
            newErrors.required.CM_CompanyGrpId = '*';
            valid = false;
        } else {
            newErrors.required.CM_CompanyGrpId = '';
            newErrors.other.CM_CompanyGrpId = '';
        }

        logAction('validateForm():Ended')
        setErrors(newErrors);
        return valid;

    };

    const handleInput = (e) => {
        const { name, value } = e.target;
        console.log('Input Change:', name, value);
        setCmEdit((prevCmEdit) => ({
            ...prevCmEdit,
            [name]: value,
        }));
        setMessage('')
    };

    // New handler for React Select changes
    const handleSelectChange = (selectedOption, fieldName) => {
        console.log('Select Change:', fieldName, selectedOption);
        setCmEdit((prevCmEdit) => ({
            ...prevCmEdit,
            [fieldName]: selectedOption ? selectedOption.value : '',
        }));
        setMessage('');
    };

    // const handleUpdate = async (e) => {
    //     e.preventDefault();
    //     // Prevent if already showing success toast
    //     // if (toast.isActive('save-toast')) {
    //     //     return;
    //     // }
    //     if (!validateForm()) {
    //         return;
    //     }
    //     setIsSubmitting(true); // Start submission
    //     setIsLoading(true); // Show loading spinner
    //     const editInputvalue = {
    //         CM_CompanyName: CMEdit.CM_CompanyName,
    //         CM_CompanyCode: CMEdit.CM_CompanyCode,
    //         CM_CompanyGrpId: CMEdit.CM_CompanyGrpId,
    //         CM_Status: CMEdit.CM_Status,
    //     };

    //     try {
    //         const saveData = await fetch(`${config.API_URL}/CM/Update/${CM_ID}`, {
    //             method: 'PATCH',
    //             headers: { 'content-type': 'application/json' },
    //             body: JSON.stringify(editInputvalue),
    //         });

    //         if (saveData.ok) {
    //             const resjson = await saveData.json();
    //             setMessage(resjson.message);
    //             showToast('success', `Company : ${CMEdit.CM_CompanyName} updated successfully.`, {
    //                 // toastId: 'save-toast', // Add unique ID
    //                 onClose: () => {
    //                     setIsLoading(false); // Hide loading spinner
    //                     navigate(`/dashboard/companymaster`);
    //                 }
    //             });

    //             logAction(`handleUpdate(): Company ${CMEdit.CM_CompanyName} updated Successfully`);
    //             setTimeout(() => {
    //                 setMessage('');
    //             }, 2000);
    //         } else {
    //             setIsLoading(false); // Hide loading spinner
    //             console.log("saveData", saveData);
    //             const errorText = await saveData.text();

    //             if (errorText.includes("Company Group")) {
    //                 showToast('error',
    //                     `You cannot activate the Company : ${CMEdit.CM_CompanyName} because Company Group is inactive.`
    //                 );
    //             }
    //             else if (errorText.includes("Company Configuration")) {
    //                 showToast('error',
    //                     `You cannot inactivate the Company : ${CMEdit.CM_CompanyName} because a reference exists in the Company Configuration.`
    //                 );
    //             }
    //             else if (errorText.includes("Company IT Policy")) {
    //                 showToast('error',
    //                     `You cannot inactivate the Company : ${CMEdit.CM_CompanyName} because a reference exists in the Company IT Policy Master.`
    //                 );
    //             }
    //             else {
    //                 showToast('error',
    //                     `Company : ${CMEdit.CM_CompanyName} could not be updated successfully.`
    //                 );
    //             }

    //             console.error('Error in saving Data:', errorText);
    //             logAction('handleUpdate(): Error in saving data.', true);
    //         }
    //     } catch (error) {
    //         setIsLoading(false); // Hide loading spinner

    //         console.log('Error updating user data:', error);
    //         const details = {
    //             AUTR_Message: `${CMEdit.CM_CompanyName} Updated`,
    //             AUTR_AuditType: "update",
    //             AUTR_NewValue: CMEdit.CM_Status === 1 ? 'Active' : CMEdit.CM_Status === 2 ? 'Inactive' : 'Unknown',
    //             AUTR_OldValue: oldstatus === 1 ? 'Active' : oldstatus === 2 ? 'Inactive' : 'Unknown',
    //         };
    //         let id = await audittrailpost(details);
    //         const details1 = {
    //             AUTRN_ParamererName: "CompanyStatus",
    //             AUTRN_NewValue: CMEdit.CM_Status === 1 ? 'Active' : CMEdit.CM_Status === 2 ? 'Inactive' : 'Unknown',
    //             AUTRN_OldValue: oldstatus === 1 ? 'Active' : oldstatus === 2 ? 'Inactive' : 'Unknown',
    //             AUTRN_ID: id,
    //         };
    //         audittransection(details1);
    //         showToast('success', `Company : ${CMEdit.CM_CompanyName} updated successfully.`, {
    //             onClose: () => {
    //                 navigate(`/dashboard/companymaster`);
    //             }
    //         });
    //         logAction(`handleUpdate():Company : ${CMEdit.CM_CompanyName} updated successfully`);
    //         setTimeout(() => {
    //             setMessage('');
    //         }, 2000);
    //         setCmEdit({
    //             CM_CompanyName: '',
    //             CM_CompanyCode: '',
    //             CM_CompanyGrpId: '',
    //             CM_Status: '',
    //         });
    //     } finally {
    //         setIsLoading(false); // Hide loading spinner

    //         // Always reset the submitting state
    //         setTimeout(() => {
    //             setIsSubmitting(false);
    //         }, 1000); // Add small delay to prevent rapid clicking
    //     }
    // };
    const handleUpdate = async (e) => {
        e.preventDefault();

        // Prevent double submit
        if (isSubmitting) return;

        if (!validateForm()) return;

        setIsSubmitting(true);
        setIsLoading(true);

        const editInputvalue = {
            CM_CompanyName: CMEdit.CM_CompanyName,
            CM_CompanyCode: CMEdit.CM_CompanyCode,
            CM_CompanyGrpId: CMEdit.CM_CompanyGrpId,
            CM_Status: CMEdit.CM_Status,
        };

        try {
            const saveData = await fetch(`${config.API_URL}/CM/Update/${CM_ID}`, {
                method: 'PATCH',
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(editInputvalue),
            });

            // ❌ API error
            if (!saveData.ok) {
                const errorText = await saveData.text();
                throw errorText;
            }

            // ✅ API success
            const resjson = await saveData.json();

            showToast(
                'success',
                `Company : ${CMEdit.CM_CompanyName} updated successfully.`,
                {
                    onClose: () => {
                        setIsLoading(false); // ✅ stop loader ONLY here
                        navigate(`/dashboard/companymaster`);
                    }
                }
            );

            logAction(`handleUpdate(): Company ${CMEdit.CM_CompanyName} updated Successfully`);

            setTimeout(() => {
                setMessage('');
            }, 2000);

        } catch (errorText) {

            // ❗ stop loader immediately on error
            setIsLoading(false);

            if (typeof errorText === 'string') {
                if (errorText.includes("Company Group")) {
                    showToast(
                        'error',
                        `You cannot activate the Company : ${CMEdit.CM_CompanyName} because Company Group is inactive.`
                    );
                }
                else if (errorText.includes("Company Configuration")) {
                    showToast(
                        'error',
                        `You cannot inactivate the Company : ${CMEdit.CM_CompanyName} because a reference exists in the Company Configuration.`
                    );
                }
                else if (errorText.includes("Company IT Policy")) {
                    showToast(
                        'error',
                        `You cannot inactivate the Company : ${CMEdit.CM_CompanyName} because a reference exists in the Company IT Policy Master.`
                    );
                }
                else {
                    showToast(
                        'error',
                        `Company : ${CMEdit.CM_CompanyName} could not be updated successfully.`
                    );
                }
            } else {
                showToast(
                    'error',
                    `Company : ${CMEdit.CM_CompanyName} could not be updated successfully.`
                );
            }

            console.error('Error in saving Data:', errorText);
            logAction('handleUpdate(): Error in saving data.', true);

        } finally {
            // Release submit lock
            setTimeout(() => {
                setIsSubmitting(false);
            }, 800);
        }
    };

    const handleCancel = () => {
        setCmEdit((prevCmEdit) => ({
            ...prevCmEdit,
            CM_Status: 1,
        }));

        setMessage('');
    };

    // Get current values for React Select
    const getCurrentCompanyGroupValue = () => {
        return companyGroupOptions.find(option => option.value === CMEdit.CM_CompanyGrpId) || null;
    };

    const getCurrentStatusValue = () => {
        return statusOptions.find(option => option.value === CMEdit.CM_Status) || statusOptions[0];
    };


    const [isSelectOpen, setIsSelectOpen] = useState(null);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };
    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };

    return (
        <React.Fragment>
            <ToastContainer
                limit={1}
                style={{
                    marginTop: '73px',
                    fontSize: '14px',
                    width: '40%',
                }} />
            {isLoading && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height

                    zIndex: 1000 // Sit on top of the other elements
                }} />
            )}
            <form onSubmit={handleUpdate} autoComplete="off">
                <div className='main_container'>
                    <h4 className='formHeading '> Company Master</h4>
                    <div className=' row'>
                        {/* <div className='form-section'> */}
                            <div className='col-md-6'>
                                <div className='mt-2'>
                                    <label className='form-label'>Company Name <span className='text-danger'>{errors.required.CM_CompanyName}</span></label>
                                    <input
                                        type='text'
                                        className='form-input' name='CM_CompanyName'
                                        value={CMEdit.CM_CompanyName}
                                        onChange={handleInput}
                                        required
                                        disabled
                                    />
                                    {errors.CM_CompanyName && <span className="text-danger">{errors.CM_CompanyName}</span>}
                                    <div className="text-danger">{errors.other.CM_CompanyName}</div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='mt-2'>
                                    <label className='form-label'>Company Code <span className='text-danger  '>{errors.required.CM_CompanyCode}</span></label>
                                    <input
                                        type='text'
                                        className='form-input' name='CM_CompanyCode'
                                        value={CMEdit.CM_CompanyCode}
                                        onChange={handleInput}
                                        required
                                        disabled
                                    />
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='mt-1'>
                                    <label className='form-label'>Company Group Name <span className='text-danger '>{errors.required.CM_CompanyGrpId}</span></label>
                                    <div className='select-container'>
                                        <Select
                                            options={companyGroupOptions}
                                            value={getCurrentCompanyGroupValue()}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'CM_CompanyGrpId')}
                                            placeholder="--Select--"
                                            isDisabled={true} // Keeping disabled as per your original code
                                            isSearchable={true}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            required
                                            onMenuOpen={() => handleSelectOpen("CM_CompanyGrpId")}
                                            onMenuClose={handleSelectClose}
                                            components={{ SingleValue: CustomSingleValue }}
                                        />
                                        <div className="icon-container_list myList">
                                            {isSelectOpen === "CM_CompanyGrpId" ? (
                                                <IoCaretUpOutline />
                                            ) : (
                                                <IoCaretDownOutline />
                                            )}
                                        </div>
                                    </div>
                                    <div className="text-danger">{errors.other.CM_CompanyGrpId}</div>
                                </div>
                            </div>

                            <div className='col-md-6'>
                                <div className='mt-1'>
                                    <label className='form-label'>Company Status </label>
                                    <div className='select-container'>
                                        <Select
                                            options={statusOptions}
                                            value={getCurrentStatusValue()}
                                            onChange={(selectedOption) => handleSelectChange(selectedOption, 'CM_Status')}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            isSearchable={false}
                                            onMenuOpen={() => handleSelectOpen("CM_Status")}
                                            onMenuClose={handleSelectClose}
                                            components={{ SingleValue: CustomSingleValue }}
                                        />
                                        <div className="icon-container_list myList">
                                            {isSelectOpen === "CM_Status" ? (
                                                <IoCaretUpOutline />
                                            ) : (
                                                <IoCaretDownOutline />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <p className='text-success'>{message}</p> */}
                        {/* </div> */}
                    </div>
                </div>
                <div className='button-container'>
                    <label className='form-lable'></label>
                    <button type='submit' className='save_btn' disabled={isSubmitting}>
                        SAVE
                    </button>
                    <button type='button' className='reset_btn' onClick={handleCancel}> RESET </button>
                    <Link to={`/cmlist/`} className='list_btn' type='button'> LIST </Link>
                </div>
            </form>
        </React.Fragment>
    );
}
export default CMEDIT;



